/**
 * Framework sử dụng in báo cáo
 */
export default {
  NetCore: 1,
  NetFramework: 2,
};
